import { Theme, useStyles } from 'bold-ui'
import { PageHeader, PageHeaderProps } from 'components/PageHeader'
import { mediaDownMd } from 'util/breakpoints'

import { PageContainer } from './layout/PageContainer'

export interface PageHeaderSectionProps extends PageHeaderProps {
  children?: React.ReactNode
  fluid?: boolean
}

export function PageHeaderSection(props: Readonly<PageHeaderSectionProps>) {
  const { children, fluid, ...rest } = props
  const { classes } = useStyles(createStyles, props)

  return (
    <div className={classes.wrapper}>
      <PageContainer fluid={fluid} style={classes.pageContainer}>
        <PageHeader style={classes.pageHeader} {...rest} />

        {children}
      </PageContainer>
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  wrapper: {
    background: theme.pallete.surface.main,
  },
  pageContainer: {
    [mediaDownMd]: {
      paddingLeft: '1rem',
      paddingRight: '1rem',
    },
  },
  pageHeader: {
    paddingTop: '2rem',
    paddingBottom: '2rem',

    [mediaDownMd]: {
      paddingTop: '1rem',
      paddingBottom: '1rem',
    },
  },
})
